import styled from 'styled-components';
import PodModal from './PodModal';
import { colorSchema } from 'utils/style';

export default styled(PodModal)`
  .pod-modal {
    display: flex;
    flex-direction: column;

    &__title {
      color: ${colorSchema('grey900')};
      font-size: 2.4rem;
      font-weight: bold;
    }

    &__subtitle {
      color: ${colorSchema('grey700')};
      font-size: 1.6rem;
    }

    &__body {
      display: flex;
      flex-wrap: wrap;
      width: 800px;
    }

    &__footer {
      display: flex;
      justify-content: flex-end;
    }

    &__button {
      margin-right: 1.6rem;

      &:last-of-type {
        margin: 0;
      }
    }
  }
`;
